/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DxSelectBoxComponent } from 'devextreme-angular';
import { DropDownOptions } from '../../models/sysque-dropdown-vm';
import { SystemInfo } from 'libs/sysque/toolbelt/data-access/src/lib/domain/system-info';

@Component({
  selector: 'sysque-select-box',
  templateUrl: './sysque-select-box.component.html',
  styleUrls: ['./sysque-select-box.component.scss'],
  standalone: false
})
export class SysqueSelectBoxComponent {
  @Input() data: SystemInfo[];
  @Input() disabled: boolean;
  @Input() key: string | null;
  @Input() showClearButton: boolean;
  @Input() placeholder: string;
  @Input() width: string;
  @Input!() cssClass: string = "";
  @Input() height: string;
  @Input() value: string;
  @Input() dropDownOptions: DropDownOptions;
  @Input() searchEnabled = false;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('dxSelectBox') dxSelectBox: DxSelectBoxComponent;

  constructor() {}

  public onValueChanged(event: any): void {
    this.valueChanged.emit(event);
  }

  public onFocusOut(): void {
    this.dxSelectBox.instance.close();
  }

  public getSelectBoxWidth(): number {
    if (this.dxSelectBox && this.dxSelectBox.instance) {
      // Get the actual width of the select box
      return this.dxSelectBox.instance.element().getBoundingClientRect().width;
    }
  }
}
